















































































import Vue, { PropType } from "vue"
import PJobCategorySearchFilter from "./pcSearchKit/PJobCategorySearchFilter.vue"
import PPublishedProjectSwitchSearchFilter from "./pcSearchKit/PPublishedProjectSwitchSearchFilter.vue"
import PPossibleOperatingMinHoursSearchFilter from "./pcSearchKit/PPossibleOperatingMinHoursSearchFilter.vue"
import PWorkingFormSearchFilter from "./pcSearchKit/PWorkingFormSearchFilter.vue"
import PSearchSort from "./pcSearchKit/PSearchSort.vue"
import FilterList from "~/components/custom/search/pcSearchKit/FilterList.vue"
import FilterListItem from "~/components/custom/search/pcSearchKit/FilterListItem.vue"
import TextField from "~/components/guideline/search/TextField.vue"
import { SearchParams } from "~/clStores/projectSearchList"
import {
  JobCategoryOption,
  WorkingFormOption,
  SearchSortOption,
} from "~/clStores/projectSearchParameterOption"
import FilterListItemFrame from "~/components/custom/search/pcSearchKit/FilterListItemFrame.vue"

type FilterType =
  | "JobCategorySearchFilter"
  | "PossibeOperatingMinHoursFilter"
  | "WorkingFormSearchFilter"
  | "SearchSort"

interface DataType {
  visibleFilter: FilterType | null
}

export default Vue.extend({
  components: {
    PJobCategorySearchFilter,
    PPublishedProjectSwitchSearchFilter,
    PPossibleOperatingMinHoursSearchFilter,
    PWorkingFormSearchFilter,
    PSearchSort,
    TextField,
    FilterList,
    FilterListItem,
    FilterListItemFrame,
  },
  props: {
    /**
     * 検索パラメータの値
     * v-modelで操作する。
     */
    value: {
      type: Object as PropType<SearchParams>,
      required: true,
    },
    jobCategoryOptions: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
    possibleOperatingMinHoursOptions: {
      type: Array as PropType<number[]>,
      required: true,
    },
    workingFormOptions: {
      type: Array as PropType<WorkingFormOption[]>,
      required: true,
    },
    searchSortOptions: {
      type: Array as PropType<SearchSortOption[]>,
      required: true,
    },
  },
  data(): DataType {
    return {
      /**
       * 表示中のフィルター
       */
      visibleFilter: null,
    }
  },
  computed: {
    jobFilterText() {
      return this.value.largeJobCategoryIds.length > 0
        ? `職種：${this.value.largeJobCategoryIds.length}`
        : "職種"
    },
    possibleOperationMinHoursFilterText() {
      if (this.value.possibleOperatingMinHours.length === 0) {
        return "稼働時間"
      }

      const selectedOptions = this.value.possibleOperatingMinHours
      return selectedOptions.length === 1
        ? `稼働時間：週${selectedOptions}時間`
        : `稼働時間：週${selectedOptions[0]}時間〜週${
            selectedOptions[selectedOptions.length - 1]
          }時間`
    },
    workingFormSearchFilterText() {
      return this.value.workingFormIds.length > 0
        ? `リモート可否：${this.value.workingFormIds.length}`
        : "リモート可否"
    },
    searchSortText() {
      const selectedOption = this.searchSortOptions.find(
        (o) => o.value === this.value.orderByScore
      )
      return selectedOption ? `並び替え：${selectedOption.label}` : "並び替え"
    },
  },
  methods: {
    toggleFilter(filterType: FilterType) {
      this.visibleFilter = filterType === this.visibleFilter ? null : filterType
    },
    changeSearchWord(newVal: string) {
      this.handleInput({
        ...this.value,
        searchWord: newVal,
      })
    },
    changeFilteredToPublishedProjectsStatus(newVal: boolean) {
      this.handleInput({
        ...this.value,
        isFilteredToPublishedProjects: newVal,
      })
      this.handleSearch()
    },
    changeJobCategoryIds(newVal: number[]) {
      this.handleInput({
        ...this.value,
        largeJobCategoryIds: newVal,
      })
      this.handleSearch()
    },
    changePossibleOperatinMinHours(newVal: number[]) {
      this.handleInput({
        ...this.value,
        possibleOperatingMinHours: newVal,
      })
      this.handleSearch()
    },
    changeWorkingForm(newVal: number[]) {
      this.handleInput({
        ...this.value,
        workingFormIds: newVal,
      })
      this.handleSearch()
    },
    changeSearchSort(newVal: boolean) {
      this.handleInput({
        ...this.value,
        orderByScore: newVal,
      })
      this.handleSearch()
    },
    handleInput(arg: SearchParams) {
      this.$emit("input", arg)
    },
    clear() {
      this.visibleFilter = null
      this.handleInput({
        isFilteredToPublishedProjects: true,
        searchWord: "",
        workingFormIds: [],
        largeJobCategoryIds: [],
        possibleOperatingMinHours:
          this.$clAuth.userProfile?.workingFormId === 2 // フリーランスの場合
            ? [20, 30, 40]
            : [1, 5, 10],
        orderByScore: true,
      })
      this.handleSearch()
    },
    handleSearch() {
      this.$emit("search")
    },
  },
})
